import { Injectable } from '@angular/core';
import { AppNotificationUtilClass, Plani8DataService } from '@monorepo/services';
import { from, lastValueFrom, of } from 'rxjs';
import { catchError, finalize, switchMap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class MetabaseDashboardsFacade {
  constructor(
    private plani8DataService: Plani8DataService,
    private appNotificationUtilClass: AppNotificationUtilClass,
  ) {}

  getPlannerMetabaseUrl() {
    return from(this.appNotificationUtilClass.presentLoading('Loading')).pipe(
      switchMap((loading) =>
        this.plani8DataService.getPlannerMetabaseUrl().pipe(
          finalize(() => {
            this.appNotificationUtilClass.dismissLoadingV2(loading);
          }),
        ),
      ),
    );
  }

  getMerchandiserMetabaseUrl() {
    return from(this.appNotificationUtilClass.presentLoading('Loading')).pipe(
      switchMap((loading) =>
        this.plani8DataService.getMerchandiserMetabaseUrl().pipe(
          finalize(() => {
            this.appNotificationUtilClass.dismissLoadingV2(loading);
          }),
        ),
      ),
    );
  }

  async getAnalyticsMetabaseUrl() {
    const loaderEl = await this.appNotificationUtilClass.presentLoading();
    const dismiss = () => this.appNotificationUtilClass.dismissLoadingV2(loaderEl);
    return lastValueFrom(
      this.plani8DataService.getAnalyticsMetabaseUrl().pipe(
        catchError(() => of(null)),
        finalize(dismiss),
      ),
    );
  }
}
